module.exports = __webpack_public_path__ + "static/media/icon-pathways.c16a965c.svg";